import React from 'react';
import { Reveal } from './Reveal';

const team = [
  {
    name: 'Robert Whitesides',
    role: 'Marketing Director',
    image: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/5x7eam00_Copy%20of%20R61_1904%20%281%29.jpg'
  },
  {
    name: 'Nikko Sortijas',
    role: 'Creative Director',
    image: 'https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/vj54j9qj_att.rnEF_tcijSNrljGpEs57GHnza_V-7vtPM2Vuztyuv8c.jpeg'
  }
];

const Team = () => {
  return (
    <section id="team" className="section-padding bg-[#0f0f0f] border-t border-white/5" data-testid="team-section">
      <div className="max-w-5xl mx-auto">
        <Reveal className="text-center max-w-3xl mx-auto mb-16">
          <p className="overline mb-5">The Collective</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
            Meet the <span className="gold-gradient">team.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-12">
          {team.map((member, index) => (
            <Reveal key={index} delay={index * 0.12}>
              <div className="group text-center" data-testid={`team-member-${index}`}>
                <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 mb-6">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 ring-0 group-hover:ring-2 ring-[#d4af37]/60 rounded-2xl transition-all duration-500 pointer-events-none"></div>
                </div>
                <h3 className="text-2xl font-semibold text-white mb-1">{member.name}</h3>
                <p className="text-[#d4af37] uppercase tracking-[0.15em] text-sm">{member.role}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
